/**
 * Logfire Logo SVG Component
 *
 * Pydantic Logfire brand logo
 */

interface LogfireLogoProps {
  className?: string;
}

export function LogfireLogo({ className }: LogfireLogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Flame shape */}
      <path
        d="M16 2C16 2 8 10 8 18C8 22.4183 11.5817 26 16 26C20.4183 26 24 22.4183 24 18C24 10 16 2 16 2Z"
        fill="url(#logfire-gradient)"
      />
      {/* Inner flame */}
      <path
        d="M16 10C16 10 12 14 12 18C12 20.2091 13.7909 22 16 22C18.2091 22 20 20.2091 20 18C20 14 16 10 16 10Z"
        fill="#FFF3E0"
      />
      {/* Spark */}
      <circle cx="16" cy="17" r="2" fill="#FF6B00" />
      <defs>
        <linearGradient
          id="logfire-gradient"
          x1="16"
          y1="2"
          x2="16"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9500" />
          <stop offset="0.5" stopColor="#FF6B00" />
          <stop offset="1" stopColor="#E53E00" />
        </linearGradient>
      </defs>
    </svg>
  );
}
